// @flow
import * as React from 'react';
import ChatWelcomeMessage from 'chat/components/ChatWelcomeMessage';

type Props = {
  stream: *,
};

function getHeader(stream: *) {
  if (stream.streamType === 'chat') {
    const { title } = stream;

    return <div>This is the beginning of your message history with {title}.</div>;
  }

  if (stream.streamType === 'entity') {
    return <div>This is the beginning of your message history.</div>;
  }

  return null;
}

class StreamHeader extends React.Component<Props, void> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const header = getHeader(this.props.stream);
    return <ChatWelcomeMessage firstHeader={header} secondHeader={null} />;
  }
}

export default StreamHeader;
